import type { FunctionComponent } from 'react';
import { paletteHelper, Text, typographyHelper } from '@property.com.au/ui-kit';
import styled from 'styled-components';
import { DialogModal } from '../../../../../app-kit/components/DialogModal/DialogModal';

interface DemographicsDataDisclaimerProps {
  opened: boolean;
  onClose: () => void;
}

const BodyText = styled(Text)`
  ${typographyHelper('body01')};
  color: ${paletteHelper('textSecondary')};
`;

export const FlatmatesDataDisclaimer: FunctionComponent<DemographicsDataDisclaimerProps> = ({
  opened,
  onClose,
}) => {
  return (
    <DialogModal
      opened={opened}
      onClose={onClose}
      title="Rental room data"
      primaryButtonText="Got it"
      primaryButtonOnClick={onClose}
    >
      <BodyText>Rental room information is sourced from flatmates.com.au</BodyText>
    </DialogModal>
  );
};
